import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
   dialogContentText: {
      paddingBottom: 10
   },
   linearProgress: {
      marginBottom: 5
   }
}))
